export default function(_this) {
  return {
    create(name, code) {
      return _this.getRef("components").push({ name, code });
    },
    read(cb, once) {
      _this.getRef("components")[once ? 'once' : 'on']("value", snapshot => {
        cb(snapshot.val());
      });
    },
    remove(key) {
      _this
        .getRef("components")
        .child(key)
        .remove();
    },
    edit(key, name, code) {
      return _this
        .getRef("components")
        .child(key)
        .update({ name, code });
    },
    savePropsDesc(cName, desc) {
      return _this
        .getRef("widgetsData/componentProps")
        .child(cName)
        .set(desc);
    },
    getPropDesc(cName) {
      return new Promise((resolve, reject) => {
        _this
          .getRef("widgetsData/componentProps")
          .child(cName)
          .once("value", snapshot => {
            resolve(snapshot.val());
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  };
}
